/**
 * `· início` (Figma `LrdQopN1jNWKJFWxOkn0IY` node `362:14912`): the assistant
 * before any question has been asked. The four suggestion cards are
 * `Suggestions.tsx`'s own concern.
 */

import { MessageSquare } from 'lucide-react';
import type { ReactNode } from 'react';

import { at } from './messages';
import { Suggestions } from './Suggestions';

export function Start(props: {
  campaignLabel: string;
  onAsk: (question: string) => void;
}): ReactNode {
  return (
    <div className="flex w-full flex-1 flex-col items-center justify-center gap-6 py-6">
      <div className="flex w-full max-w-3xl flex-col items-center gap-5">
        <div className="flex size-13 shrink-0 items-center justify-center rounded-pill bg-primary-quiet">
          <MessageSquare aria-hidden className="size-6 text-primary-ink" />
        </div>
        <div className="flex flex-col items-center gap-2 text-center">
          <h1 className="text-title-lg text-foreground">
            {at('start.heading', { campaign: props.campaignLabel })}
          </h1>
          <p className="max-w-xl text-body text-muted-foreground">{at('start.subtitle')}</p>
        </div>
        <Suggestions onAsk={props.onAsk} />
      </div>
    </div>
  );
}
